import { Provider } from "@angular/core";
import { ProcesoRespuestas } from "./ProcesoRespuestas";
import { ProcesoRespuestasImpl } from "./ProcesoRespuestasImpl";
import { CacheRespuestas } from "./CacheRespuestas";
import { CacheRespuestasImpl } from "./CacheRespuestasImpl";
import { PasosProviders } from "./Pasos/PasosProviders";

export const ProcesoRespuestasProviders: Provider[] = [
    ...PasosProviders,
    { provide: ProcesoRespuestas, useClass: ProcesoRespuestasImpl },
    { provide: CacheRespuestas, useExisting: CacheRespuestasImpl }
];
